import React, { FC } from "react";
import { InfoModal } from "./InfoModal";

interface Props {
  open: boolean;
  handleClose: () => void;
}

export const MassimaleModal: FC<Props> = (props: Props) => {
  return (
    <InfoModal
      title="Cos'è un MASSIMALE"
      description="Il massimale di un contratto di assicurazione deve essere specificato in ogni contratto, e rappresenta la somma massima che la compagnia di assicurazione pagherà, nel caso in cui si dovesse verificare l'evento per il quale è stato stipulato il contratto stesso."
      {...props}
    />
  );
};
